<template>
  <v-dialog width="min(90%, 1300px)" v-model="dialog">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" v-on="on" class="mb-4"> Добавить акцию</v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-2 pa-md-4"> Правила акции</v-card-title>
      <v-card-text class="pa-2 pa-md-4">
        <v-form ref="form">
          <v-row no-gutters>
            <v-col cols="12" md="6" offset-md="3">
              <v-text-field v-model.trim="promoTitle" :rules="[requiredRule]" dense label="Название акции" />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" md="6" offset-md="3">
              <v-text-field v-model.trim="promoDescription" dense :rules="[requiredRule]" label="Описание акции" />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col cols="12" md="3" offset-md="3" class="pr-md-2">
              <v-menu
                v-model="datePickerStart"
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateStartFormatted"
                    label="Дата начала акции"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    :rules="[requiredRule, dateEndRule]"
                    autocomplete="off"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateStart"
                  no-title
                  @input="datePickerStart = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3" class="pr-md-2">
              <v-menu
                v-model="datePickerEnd"
                :close-on-content-click="false"
                transition="scale-transition"
                max-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateEndFormatted"
                    label="Дата завершения акции"
                    prepend-icon="mdi-calendar"
                    v-bind="attrs"
                    v-on="on"
                    :rules="[dateEndRule]"
                    autocomplete="off"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dateEnd"
                  no-title
                  @input="datePickerEnd = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="3">
              <v-switch class="mt-1" label="Для всех" dense v-model="forAll" />
            </v-col>
            <v-col cols="12" md="6" offset-md="3" v-if="!forAll">
              <v-textarea placeholder="Введите через запятую ИНН всех участников акции" v-model="inns"
                          :rules="[requiredRule, innsRule]"></v-textarea>
            </v-col>
          </v-row>


          <v-row no-gutters>
            <v-col cols="12" md="6" offset-md="3">
              <v-select
                v-model="target"
                :items="targetItems"
                :disabled="targetDisabled"
                item-text="name"
                item-value="value"
                label="Целевой показатель:"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-switch class="mt-1" label="По субпартнёрам" dense v-model="forSubs" />
            </v-col>
          </v-row>

          <v-row no-gutters v-if="target">
            <v-col cols="12" md="6" offset-md="3">
              <v-tabs v-model="currentTab">
                <v-tab v-for="(tab, index) in promoTabs" :key="tab.id">
                  {{ tab.tp + " " + tab.rewardModel }}
                  <v-btn text small color="error" v-if="index !== 0" @click="promoTabs.splice(index, 1)">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>

          <v-tabs-items v-model="currentTab" v-if="target">
            <v-tab-item
              v-for="(tab, tabIndex) in promoTabs"
              :key="tab.id">

              <v-row no-gutters>
                <v-col cols="12" md="6" offset-md="3">
                  <v-radio-group v-model="tab.tp" row label="ОФП бенефициара:" class="mt-1"
                                 :rules="[requiredRule, tpRewmodelRule(tab, tabIndex)]"
                                 @change="$event === 'SC' ? tab.rewardModel = 'revshare' : null">
                    <v-radio label="Физ. лицо" value="FL" />
                    <v-radio label="Юр. лицо" value="UL" />
                    <v-radio label="ИП" value="IP" />
                    <v-radio label="Скаут" value="SC" />
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col cols="12" md="6" offset-md="3">
                  <v-radio-group v-model="tab.rewardModel"
                                 row
                                 label="Тип вознаграждения:"
                                 :rules="[requiredRule, tpRewmodelRule(tab, tabIndex)]"
                                 class="mt-1">
                    <v-radio label="Фиксированный" value="revshare" />
                    <v-radio
                      label="Прогрессивный"
                      value="progressive"
                      :disabled="target === 'shar_coefficient' || target === 'ost_q' || tab.tp === 'SC'"
                    />
                  </v-radio-group>
                </v-col>
              </v-row>

              <v-row v-if="target === 'shar_coefficient' || target === 'ost_q'">
                <v-col cols="12" md="6" offset-md="3">
                  <v-text-field
                    v-if="target === 'shar_coefficient'"
                    label="Проценты"
                    :key="target"
                    dense
                    append-icon="mdi-percent"
                    v-model.trim="tab.sharPercent"
                    :rules="[floatRule, requiredRule]"
                  />
                  <v-text-field
                    v-else
                    label="Проценты"
                    :key="target"
                    dense
                    append-icon="mdi-percent"
                    v-model.trim="tab.ostPercent"
                    :rules="[floatRule, requiredRule]"
                  />
                </v-col>
              </v-row>

              <template v-else-if="target === 'fixed_cost'">
                <v-row no-gutters>
                  <v-col cols="12" md="6" offset-md="3">
                    <v-radio-group row v-model.trim="tab.fixedCostPeriod" label="Период подсчёта приведённых клиентов:">
                      <v-radio label="Всё время" value="ever" />
                      <v-radio label="Месяц" value="month" />
                    </v-radio-group>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col cols="12" md="3" offset-md="3" class="pr-2">
                    <v-text-field
                      label="Выплата за активацию"
                      dense
                      v-model.trim="tab.activationCost"
                      :rules="[intRule]"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Срок на активацию (дней)"
                      dense
                      v-model.trim="tab.daysAfterCreate"
                      :rules="[daysAfterCreateRule(tab), intRule]"
                    />
                  </v-col>
                </v-row>

                <v-row no-gutters v-for="(range, index) in tab.fixedRanges">
                  <v-col cols="6" offset-md="3" md="2" class="pr-2">
                    <v-text-field
                      label="От"
                      dense
                      v-model.trim="range.from"
                      :rules="[requiredRule, intRule, prevRangeRule(index, tab.fixedRanges)]"
                    />
                  </v-col>
                  <v-col cols="6" md="2" class="pr-md-2">
                    <v-text-field
                      label="До"
                      dense
                      v-model.trim="range.to"
                      :rules="[requiredRule, intRule, fromToRangeRule(range)]"
                    />
                  </v-col>
                  <v-col cols="6" md="2" class="pr-2">
                    <v-text-field
                      label="Вознаграждение"
                      dense
                      v-model.trim="range.cost"
                      :rules="[requiredRule, intRule]"
                    />
                  </v-col>
                  <v-col cols="6" md="2">
                    <v-btn text v-if="index !== 0" small>
                      <v-icon color="error" @click="deleteRange(index)">mdi-delete-circle</v-icon>
                    </v-btn>
                    <v-btn text v-if="index === tab.fixedRanges.length - 1" small>
                      <v-icon color="primary" @click="createNewRange">mdi-plus-circle</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </template>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-1 pa-md-4">
        <v-row no-gutters>
          <v-spacer />
          <v-btn color="error" @click="dialog = false" class="mb-1 mb-md-0 mr-sm-2">Отмена</v-btn>
          <v-btn color="secondary" v-if=" target" class="ml-auto ml-md-0 mb-1 mr-sm-2 mb-md-0" @click="newTab"> Добавить
            категорию
          </v-btn>
          <v-btn color="primary" v-if="target" class="ml-auto ml-md-0 mr-sm-2" @click="createPromo"> Сохранить</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createPromo } from "@/api/promos";
import dateFormat from "@/utils/formatDate";
import { validateInn } from "@/utils/helpers";

const dateMask = "dd/mm/yyyy";

const emptyFixedRange = { from: undefined, to: undefined, cost: undefined };

class Tab {
  constructor(id) {
    this.id = id;
    this.rewardModel = undefined;
    this.tp = undefined;
    this.activationCost = null;
    this.sharPercent = null;
    this.ostPercent = null;
    this.fixedCostPeriod = "ever";
    this.fixedRanges = [{ ...emptyFixedRange }];
    this.daysAfterCreate = null;
  }
}


export default {
  data() {
    return {
      dateStart: null,
      forSubs: false,
      inns: "",
      datePickerStart: false,
      dateEnd: null,
      datePickerEnd: false,
      dialog: false,
      promoTitle: undefined,
      promoDescription: undefined,
      forAll: true,
      target: undefined,
      targetDisabled: false,
      targetItems: [
        { name: "Выплата за привод нового клиента", value: "fixed_cost" },
        { name: "Процент от остатка на счёте приглашённых клиентов", value: "ost_q" },
        { name: "Процент от операций приглашённых клиентов", value: "shar_coefficient" },
      ],
      currentTab: null,
      promoTabs: [new Tab(0)],
      nextId: 1,
      requiredRule: (v) => !!v || "Обязательное поле",
      intRule: (v) => {
        return (
          (isNaN(parseInt(v)) === false && String(parseInt(v)) === v && parseInt(v) > 0) ||
          !v ||
          "Введите натуральное число"
        );
      },
      floatRule: (v) => {
        return (isNaN(parseFloat(v)) === false && parseFloat(v) >= 0) || !v || "Введите число";
      },
      dateEndRule: () => {
        return (Date.parse(this.dateEnd) >= Date.parse(this.dateStart)) || !this.dateEnd || "Дата завершения должна быть не ранее даты начала акции";
      },
      innsRule: () => {
        let flag = true;
        const inns = this.inns.split(",");
        for (let inn of inns) {
          if (!validateInn(inn)) {
            flag = false;
            break;
          }
        }
        return flag || "Некоторые из введенных ИНН невалидны";
      },
      daysAfterCreateRule: (tab) => tab.activationCost ? !!tab.daysAfterCreate || "Обязательное поле" : true
    };
  },
  methods: {
    createNewRange() {
      this.promoTabs[this.currentTab].fixedRanges.push({ ...emptyFixedRange });
    },
    deleteRange(i) {
      this.promoTabs[this.currentTab].fixedRanges.splice(i, 1);
    },
    newTab() {
      if (this.$refs.form.validate()) {
        this.promoTabs.push(new Tab(this.nextId));
        this.nextId++;
        this.currentTab = this.promoTabs.length - 1;
      }
    },
    fromToRangeRule({ from, to }) {
      if (parseFloat(from) <= parseFloat(to) || isNaN(parseFloat(to))) return true;
      else return "Верхняя граница должна быть больше либо равна нижней";
    },
    prevRangeRule(index, all_ranges) {
      if (parseFloat(all_ranges[index]?.from) > parseFloat(all_ranges[index - 1]?.to) || index === 0) return true;
      else return "Значение нижней гранцы N диапазона должно быть больше значения верхней гграницы N-1 диапазона";
    },
    tpRewmodelRule(checkingTab, checkingTabIndex) {
      const foundIndex = this.promoTabs.findIndex((tab, index) => {
        return tab.tp === checkingTab.tp && tab.rewardModel === checkingTab.rewardModel && index !== checkingTabIndex;
      });
      return foundIndex === -1 || `Условия для данного сочетания типа вознаграждения и ОФП уже прописаны во вкладке ${foundIndex + 1}`;
    },
    async createPromo() {
      if (this.$refs.form.validate()) {
        const promoBase = {
          name: this.promoTitle,
          description: this.promoDescription,
          for_all: this.forAll,
          partner_inn: !this.forAll ? this.inns.split(",") : undefined,
        };

        const rules = [];
        this.promoTabs.forEach((tab) => {
          const tabBase = {
            date_begin: this.dateStart + "T00:00:00",
            date_end: this.dateEnd ? (this.dateEnd + "T00:00:00") : undefined,
            rewardmodel: tab.rewardModel,
            tp: tab.tp,
            sub: this.forSubs ? 1 : undefined,
          };
          if (this.target === "shar_coefficient") {
            rules.push({
              ...tabBase,
              shar_coefficient: parseFloat(tab.sharPercent) / 100,
            });
          } else if (this.target === "ost_q") {
            rules.push({
              ...tabBase,
              ost_q: parseFloat(tab.ostPercent) / 100,
            });
          } else {
            if (tab.activationCost) rules.push({
              ...tabBase,
              activate_client: parseInt(tab.activationCost),
              days_after_create: parseInt(tab.daysAfterCreate),
            });
            tab.fixedRanges.forEach((range) => {
              if (tab.fixedCostPeriod === "ever") {
                if (this.forSubs) {
                  rules.push({
                    ...tabBase,
                    clients_sub_ever_begin: parseInt(range.from),
                    clients_sub_ever_end: parseInt(range.to),
                    fix_cost: parseInt(range.cost),
                  });
                } else {
                  rules.push({
                    ...tabBase,
                    clients_ever_begin: parseInt(range.from),
                    clients_ever_end: parseInt(range.to),
                    fix_cost: parseInt(range.cost),
                  });
                }
              } else {
                rules.push({
                  ...tabBase,
                  clients_begin: parseInt(range.from),
                  clients_end: parseInt(range.to),
                  fix_cost: parseInt(range.cost),
                });
              }
            });
          }
        });
        await createPromo(promoBase, rules);
        this.$emit("promo-created");
        this.$refs.form.reset();
        this.dialog = false;
      }
    },
  },
  watch: {
    rewardModel(newValue) {
      if (newValue === "progressive") {
        this.target = "fixed_cost";
        this.targetDisabled = true;
      } else this.targetDisabled = false;
    },
    inns(newVal) {
      this.inns = newVal.replace(/[^\d,]/g, "");
    },
  },
  computed: {
    dateStartFormatted: {
      get() {
        return this.dateStart ? dateFormat(this.dateStart, dateMask) : null;
      },
      set(newVal) {
        this.dateStart = newVal;
      },
    },
    dateEndFormatted: {
      get() {
        return this.dateEnd ? dateFormat(this.dateEnd, dateMask) : null;
      },
      set(newVal) {
        this.dateEnd = newVal;
      },
    },
  },
}
;
</script>

<style scoped lang="scss"></style>
